import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { ToastViewport } from '@shared/ui/feedback/Toast';
import { CrashScreen } from '@shared/ui/feedback/CrashScreen';
import { NativePushBridge } from '@features/notifications/NativePushBridge';
import { TenantSwitchPrompt } from '@features/notifications/TenantSwitchPrompt';
import { queryClient } from '@shared/lib/queryClient';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps): JSX.Element {
  return (
    <ErrorBoundary FallbackComponent={CrashScreen}>
      <QueryClientProvider client={queryClient}>
        <NativePushBridge />
        {children}
        <TenantSwitchPrompt />
        <ToastViewport />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export { queryClient };
